<template>
	<AppDialog :max-width="620" class="publish-errors">
		<div class="publish-errors">
			<div class="main-title text-center mt-6">Publishing feature could not finish successfully</div>
			<div class="sub-title text-center">Publishing encountered a few dependency issues that need to be taken care of first</div>
			<div class="sub-title text-center">Please go to these steps and fix the missing dependencies</div>
			<div class="display-flex flex-column fill-height px-8">
				<div v-for="(node, ind) in nodes" :key="ind">{{ ind + 1 }}. {{ nodeTitle(node) }} (Step {{ stepNumber(node) }})</div>
			</div>
			<div class="dialog-bottom text-align-center my-4">
				<PrimaryButton @click="close">OK</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { getNode } from '@/store/modules/nodes/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { selectedWorkflowId } from '@/store/modules/selectedWorkflow/getters';
import { nodesDataSorted } from '@/store/modules/workflows/getters';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'PublishFlowErrorsDialog',
	props: {
		erroredNodes: { type: Array },
		dialogPromiseHandlers: { type: Object },
	},
	components: {
		AppDialog,
	},
	computed: {
		...mapGettersShorthand({ getNode, nodesDataSorted, selectedWorkflowId }),
		nodes() {
			return this.erroredNodes.map((x) => this.getNode(x));
		},
	},
	methods: {
		nodeTitle(node) {
			return node?.node_title;
		},
		stepNumber(node) {
			return this.nodesDataSorted(this.selectedWorkflowId)?.findIndex((x) => x?.uuid === node?.uuid) + 1;
		},
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
	},
};
</script>

<style scoped lang="scss">
.publish-errors {
	.main-title {
		font-size: 22px;
		font-weight: bold;
	}
	.sub-title {
		font-size: 12px;
	}
}
</style>
